import { Box, Skeleton } from "@mui/material";

export default function AdvanceTradeAvailableSkeleton() {
  return (
    <Box>
      <Skeleton variant="rounded" width="100%" height={280} />
    </Box>
  );
}
